module.exports = __webpack_public_path__ + "060f800ea6fb63e38d09bbe36ba462d8.pdf";